var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WrappingComponent',{attrs:{"settings":_vm.settings,"formData":_vm.form}}),_c('ContactsComponent',{attrs:{"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }